import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentTaskId: null,
  loading: false,
  pipelineStage: null,
  result: null,
  error: null,
  /** Имя файла последнего отправленного изображения (для выгрузки контекста поиска) */
  lastSubmittedFileName: null,
  /** Сжатый base64 (без префикса data:) последнего глобального поиска по картинке */
  lastSubmittedImageBase64: null,
};

const globalSearchSlice = createSlice({
  name: 'globalSearch',
  initialState,
  reducers: {
    globalSearchStart: (state, action) => {
      const { taskId, fileName, imageBase64 } = action.payload || {};
      state.currentTaskId = taskId != null ? String(taskId) : null;
      state.loading = true;
      state.pipelineStage = null;
      state.result = null;
      state.error = null;
      state.lastSubmittedFileName =
        fileName != null && String(fileName).trim() !== '' ? String(fileName) : null;
      state.lastSubmittedImageBase64 =
        imageBase64 != null && String(imageBase64).trim() !== ''
          ? String(imageBase64).trim()
          : null;
    },
    globalSearchSubtaskUpdate: (state, action) => {
      const {
        taskId,
        pipelineStage,
        status,
        partial,
        error,
        message,
      } = action.payload;

      if (
        taskId != null &&
        state.currentTaskId != null &&
        String(state.currentTaskId) !== String(taskId)
      ) {
        return;
      }

      if (error) {
        state.loading = false;
        state.error = message || 'Ошибка';
        return;
      }

      if (pipelineStage != null) {
        state.pipelineStage = pipelineStage;
      }

      if (partial && typeof partial === 'object') {
        state.result = state.result ? { ...state.result, ...partial } : { ...partial };
      }

      const done =
        status === 'completed' ||
        status === 'success' ||
        pipelineStage === 'completed';

      if (done) {
        state.loading = false;
      }

      if (status === 'error' || pipelineStage === 'error') {
        state.loading = false;
        state.error = message || 'Ошибка';
      }
    },
    globalSearchReset: () => ({ ...initialState }),
  },
});

export const {
  globalSearchStart,
  globalSearchSubtaskUpdate,
  globalSearchReset,
} = globalSearchSlice.actions;

export default globalSearchSlice.reducer;
